import React from "react"
import { createRoot } from "react-dom/client"
import { IntlProvider } from "react-intl"
import { CssBaseline } from "@mui/material"
import { ThemeProvider, createTheme } from "@mui/material/styles"
import { getLocale, getMessages } from "./locale.js"
import Router from "./router.js"
import * as serviceWorker from "./serviceWorker"
import { Provider } from "react-redux"
import store from "./store.js"
import TagManager from "react-gtm-module"
import { blue, green, orange, pink, red } from "@mui/material/colors"

const locale = getLocale()
const TRACKING_ID_GA4 = process.env.REACT_APP_GA4_GTM_ID

if (String(TRACKING_ID_GA4) !== "DUMMY") {
  const tagManagerArgsGa4 = {
    gtmId: TRACKING_ID_GA4,
  }
  TagManager.initialize(tagManagerArgsGa4)
}

// MUI v5のデフォルトテーマを作成
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    background: {
      default: "#fafafa",
    },
    primary: {
      light: blue[400],
      main: blue[700],
      dark: blue[900],
    },
    secondary: {
      light: pink["A200"],
      main: pink["A400"],
      dark: pink["A700"],
    },
    error: {
      light: red[300],
      main: red[500],
      dark: red[700],
    },
    warning: {
      light: orange[300],
      main: orange[500],
      dark: orange[700],
    },
    info: {
      light: blue[300],
      main: blue[500],
      dark: blue[700],
    },
    success: {
      light: green[300],
      main: green[500],
      dark: green[700],
    },
  },
})

const container = document.getElementById("root")
const root = createRoot(container)

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <IntlProvider locale={locale} messages={getMessages()}>
        <Router />
      </IntlProvider>
    </ThemeProvider>
  </Provider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
